import React from 'react'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import ReliabilityAIHealth from '../molecules/AIHealthComponents/ReliabilityAIHealth/ReliabilityAIHealth'
import AIHealthSolutions from '../molecules/AIHealthComponents/AIHealthSolutions/AIHealthSolutions'
import AIHealthIdeaProject from '../molecules/AIHealthComponents/AIHealthIdeaProject'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import { getPageData, useData } from '../../app/helper/functions'
import AppsMaintenance from '../molecules/AppsSupportComponents/AppsMaintenance/AppsMaintenance'
import { motion } from 'framer-motion'
import AiHealthIllustration from "../../app/assets/images/AI-health-illustration.svg";

const   AIHealthcarePage = () => {
    const { data } = useData();
    const aiHealthcareData = getPageData(data, 'aiHealthcarePage');
    return (
        <div className='overflow-x-hidden'>
            <div className='bg-aiHealthcare-bg bg-center bg-cover bg-no-repeat'>
                <div className='bg-blackTransparent'>
                    <div className='flex flex-col px-[5%] sm:px-[7%] md:px-[10%] pb-4 sm:pb-6 md:pb-8 pt-32 md:pt-40 lg:pt-52 justify-center items-center'>
                        <motion.img 
                            src={AiHealthIllustration} 
                            className='z-10 w-[90%] sm:w-[70%] md:w-[60%]'
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.8 }}
                        />
                        <motion.div 
                            className='text-white flex flex-col gap-2 relative text-center px-4'
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.8, delay: 0.3 }}
                        >
                            <motion.div 
                                className='font-bold text-3xl sm:text-5xl md:text-6xl lg:text-7xl mb-2'
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.3 }}
                                transition={{ duration: 0.6, delay: 0.5 }}
                            >
                                {aiHealthcareData.title}
                            </motion.div>
                            <motion.div 
                                className='font-normal text-lg sm:text-xl md:text-2xl'
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.3 }}
                                transition={{ duration: 0.6, delay: 0.7 }}
                            >
                                {aiHealthcareData.description}
                            </motion.div>
                        </motion.div>
                    </div>
                </div>
            </div>
            <div className='bg-darkGreyPrimary'>
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: false, amount: 0.3 }}
                >
                    <Heading className='bg-darkGreyPrimary pt-8 sm:pt-10 md:pt-12 px-4 sm:px-6'
                        subTitle='The impact of AI on the future of healthcare'
                        text="AI is changing how healthcare providers deliver services and communicate with patients.
                        Integrating AI can enhance patient outcomes, optimize workflows, and improve
                        diagnostic precision by analyzing data and automating tasks." />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: false, amount: 0.3 }}
                    className="px-4 sm:px-6 md:px-8"
                >
                    <ReliabilityAIHealth aiHealthcareData={aiHealthcareData} />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 0 }}
                    whileInView={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: false, amount: 0.1 }}
                    className="px-4 sm:px-6 md:px-0"
                >
                    <AIHealthIdeaProject aiHealthcareData={aiHealthcareData} />
                </motion.div>
                
                <div className='pt-6 sm:pt-8 md:pt-10 bg-darkGreyPrimary'>
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false, amount: 0.3 }}
                    >
                        <AppsRunning bgImage='bg-confident-aiHealth-bg' title='We have your system ready!' subtitle="Don't worry, you are in the right place." />
                    </motion.div>
                </div>
                
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: false, amount: 0.3 }}
                    className="px-4 sm:px-6 md:px-0"
                >
                    <AIHealthSolutions />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: false, amount: 0.3 }}
                    className="px-4 sm:px-6 md:px-0"
                >
                    <ProjectDisplay />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: false, amount: 0.3 }}
                    className="px-4 sm:px-6 md:px-0"
                >
                    <AppsFaq />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: false, amount: 0.3 }}
                >
                    <AppsMaintenance bgImage='bg-maintenance-serviceAi-bg' title='Are you looking for help in creating your AI solution?' subtitle="Don't worry, you are in the right place." />
                </motion.div>
                
                <DefaultFooter />
            </div>
        </div>
    )
}

export default AIHealthcarePage
